import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api'

export const IMC_METRICS_REQUEST = 'IMC_METRICS_REQUEST'
export const IMC_METRICS_SUCCESS = 'IMC_METRICS_SUCCESS'
export const IMC_METRICS_FAILURE = 'IMC_METRICS_FAILURE'

export function requestIMCMetrics(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/imc-metrics?${query}`,
      method: 'GET',
      types: ['IMC_METRICS_REQUEST', 'IMC_METRICS_SUCCESS', 'IMC_METRICS_FAILURE']
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/imc/IMCActions.js